module.exports = __webpack_public_path__ + "static/data_sourcer-d07ddb3e699e8eded180e76d9598c253.svg";